<template>
<div>
        <div class="top-hero">
           
              <div id="section-home" class="relative overflow-hidden">
                <div aria-hidden="true" class="absolute inset-0 -mt-72 sm:-mt-32 md:mt-0">
                  <svg class="absolute inset-0 h-full w-full" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 1463 360">
                    <path class="text-blue-800 text-opacity-20" fill="currentColor" d="M-82.673 72l1761.849 472.086-134.327 501.315-1761.85-472.086z" />
                    <path class="text-blue-900 text-opacity-40" fill="currentColor" d="M-217.088 544.086L1544.761 72l134.327 501.316-1761.849 472.086z" />
                  </svg>
                </div>

                <div class="relative">

                    <div class="relative overflow-hidden -mt-24 sm:-mt-0">
                      <div class="p-8 mb-4 mx-auto max-w-7xl px-4 sm:mt-8 sm:px-6">

                          <p class="text-center text-white">
                            Service Disabled Veteran Owned<br>
                            Highly skilled developers placing client needs first
                          </p>
                          <h2 class="sm:mt-8 text-white text-center"><i class="fa fa-copyright" aria-hidden="true"></i>
                            Copyright Vision Quest Venture
                          </h2>

                        </div>

                    </div>

                </div>
              </div>

 
        </div>



</div>

</template>

<script>
export default {
  data() {
    return {};
  },


};
</script>
